module.exports = __webpack_public_path__ + "static/media/Cabs2.0-275-100-A.1c434525.png";